import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Platform } from '@ionic/angular';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AppSettings } from 'src/app/core/configs/app.settings';
import { HttpService } from 'src/app/core/data/service/http.service';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService extends HttpService {

  constructor(
    http: HttpClient,
    private authService: AuthenticationService,
    private platform: Platform,
    private gtmService: GoogleTagManagerService) {

    super(http);

    this.endpoint = `${this.apiURL}/analytics`;
  }

  async submitSession() {
    try {
      const session = {
        platform: this.platform.platforms().join('>'),
        userAgent: navigator.userAgent,
        appVersion: AppSettings.version
      };
      await this.post(session, `${this.endpoint}/session`);
    } catch (error) {
      console.error('Error submitting session info. Error: ', error);
    }
  }

  logPageEvent(page: string, data: string = '') {
    this.registerTag(TagEventType.Page, page, data);
  }

  logEngagementEvent(page: string, data: string = '') {
    this.registerTag(TagEventType.Engagement, page, data);
  }

  logClickEvent(page: string, data: string = '') {
    this.registerTag(TagEventType.Click, page, data);
  }

  logFlowEvent(page: string, data: string = '') {
    this.registerTag(TagEventType.Flow, page, data);
  }

  logCreateAuction(accessCode: string = '') {
    this.gtmService.pushTag(
      {
        event: TagEventType.CreateAuction,
        auction: accessCode
      }
    );
  }

  logURFEvent(accessCode: string = '') {
    this.gtmService.pushTag({
      event: TagEventType.URFSetup,
      auction: accessCode
    });
  }

  logGenericEvent(page: string, data: string = '') {
    this.registerTag(TagEventType.Generic, page, data);
  }

  logUserEvent(key: string, firstOnly = true) {
    // Determine the os
    let value = 0;
    let device = 'web';
    if (this.platform.is('android')) {
      value = 1;
      device = 'android';
    } else if (this.platform.is('ios')) {
      device = 'ios';
      value = 2;
    }

    // Load the user stats
    const userInfo = JSON.parse(localStorage.getItem(`stats-${this.authService.profile.userId}`) || '{}');
    if (userInfo[key] == null || firstOnly === false) {
      // We will only log the event if we don't say first only
      userInfo[key] = true;
      switch (key) {
        case 'Register':
          this.gtmService.pushTag(
            {
              event: TagEventType.CreateAccount,
              device
            }
          );
          break;
        case 'Login':
          this.logEngagementEvent('User First Login', `DeviceLogin ${value}`);
          break;
        case 'Bid':
          this.logEngagementEvent('User First Bid', `DeviceBid ${value}`);
          break;
      }
      // Store the current user info
      localStorage.setItem(`stats-${this.authService.profile.userId}`, JSON.stringify(userInfo));
    }
  }

  // logTransactionEvent(sku: ISku) {
  //   Log.debug(sku);
  //   this.gtmService.pushTag(
  //     {
  //       event: TagEventType.PayNow,
  //       value: sku == null ? 0 : sku.costCdn, // value and cost will be set to CDN price
  //       cost: sku == null ? 0 : sku.costCdn,  // the user may pay in USD but for analytics we only want to track in CDN
  //       currency: 'cad',
  //     }
  //   );
  // }

  logAccountCreation() {
    let device = 'web';
    if (this.platform.is('android')) {
      device = 'android';
    } else if (this.platform.is('ios')) {
      device = 'ios';
    }
    this.gtmService.pushTag(
      {
        event: TagEventType.CreateAccount,
        device
      }
    );

  }

  protected isUpdate(entity: any): boolean {
    throw new Error('Method not implemented.');
  }
  protected getUpdateUrl(entity: any): string {
    throw new Error('Method not implemented.');
  }

  private registerTag(eventType: TagEventType, customData: string, dataIdentifier: string) {
    const gtmTag = {
      event: eventType,
      data: customData,
      identifier: dataIdentifier
    };
    this.gtmService.pushTag(gtmTag);
  }

}

export enum TagEventType {
  Click = 'Click',
  Engagement = 'Engagement',
  Page = 'Page',
  Flow = 'Flow',
  Submission = 'Submission',
  Conversion = 'Conversion',
  Generic = 'Event',
  CreateAccount = 'Create_Account',
  CreateAuction = 'Create_Auction',
  PayNow = 'Pay_Now',
  URFSetup = 'URF_Setup'
}
